import {Pipe, PipeTransform} from '@angular/core';
import {Patient} from "@allaihealth/util";
import {Utils} from '@allaihealth/ng-platform';

/** Simple pipe for outputting {@link Utils.getAgeAndSex} for a patient */
@Pipe({
	name: 'ageSex'
})
export class AgeSexPipe implements PipeTransform {

	transform(patient:Patient):string {
		return Utils.getAgeAndSex(patient);
	}
}
